module.exports = __webpack_public_path__ + "static/media/img_qudao10@2x.87e221b0.png";